module.exports = __webpack_public_path__ + "img/tiaoguo_en_hover.87884aef.png";